export default "__VITE_ASSET__D$_9CQXq__"